import { tViews } from "../../../../../utils/table";

export const columnsCircuitName = () => [
  {
    prop: "circuit_display_name",
    name: tViews('circuitViewCircuits'),
    size: 160
  },
  {
    prop: "availability",
    name: tViews('circuitViewAvailability'),
    size: 130,
    columnTemplate: createElement => {
      const content = createElement("div", {
        style: {
          display: "flex",
          alignItems: "center"
        },
        innerHTML: `${tViews('circuitViewAvailability')}
                      <hbr-tooltip
                      content-id="some-id"
                      content="Circuit availability and trend (+/-) compared with previous time range selection"
                    >
                      <hbr-icon name="info" sentiment="neutral"></hbr-icon>
                    </hbr-tooltip>`
      });
      return [content];
    }
  }
];

export const getSourceCircuit = data => {
  return data.map(element => {
    return {
      circuit_name: element.circuit_display_name,
      availability_display: element.availability_display
    };
  });
};
